    <!-- Header -->
    <div class="modal-header" mat-dialog-title>
        <div class="modal-header-icon">
            <mat-icon class="material-symbols-outlined">tune</mat-icon>
        </div>
        <div class="modal-header-titles">
            <h2 class="modal-title">{{ isEditMode ? 'Editar Exceção' : 'Nova Exceção' }}</h2>
        </div>
        <div class="modal-header-close-btn-container">
            <button mat-icon-button type="button" class="modal-close-btn" (click)="fechar()">
                <mat-icon class="material-symbols-outlined">close</mat-icon>
            </button>
        </div>
    </div>

    <!-- Passos indicadores -->
    <app-wizard-steps [passos]="passos" [descricoes]="descricoesPassos" [passoAtual]="passo" [flush]="true" [clicavel]="true" (passoSelecionado)="onPassoSelecionado($event)"></app-wizard-steps>

    <mat-dialog-content class="modal-content wizard-content">

        <!-- ── Passo 1: Escopos ──────────────────────────────────────────────── -->
        @if (passo === 0) {
        <div class="escopo-section">

            <div class="escopo-grupos-lista">
                @for (grupo of gruposEscopoDefinicao; track grupo.grupo) {
                <div class="section-container"><div class="section-title"><mat-icon class="material-symbols-outlined">{{ iconeEscopoGrupo(grupo.grupo) }}</mat-icon><span>{{ grupo.labelGrupo }}</span></div>
                    @for (g of gruposEscopo; track g.tipo) { @if (g.grupo === grupo.grupo) {
                    <div class="sub-section-container"><div class="sub-section-title"><mat-icon class="material-symbols-outlined">{{ iconeTipoEscopo(g.tipo) }}</mat-icon><span>{{ g.label }}</span></div>

                    @if (g.tipo === TipoEscopoEnum.IndicadorInscricaoEstadual) {
                    <div class="escopo-input-row"><div class="escopo-input-field"><app-select-pesquisavel [control]="$any(g.tempControl)" [label]="g.label" [offlineList]="listaIndicadorInscricaoEstadual" idField="id" nameField="descricao" [multiple]="true" [isOptional]="true" subscriptSizing="dynamic" (selectionChange)="onMultiSelectChange(g, $event)"></app-select-pesquisavel></div></div>
                    @if (g.valores.length > 0) { <div class="status-badge-grid mt-2">@for (v of g.valores; track v.codigo) { <span class="status-badge badge-cinza">{{ badgeLabel(v) }}<button type="button" class="badge-close-btn" (click)="removerValorGrupo(g, v)"><mat-icon>close</mat-icon></button></span> }</div> }
                    }
                    @else if ((g.tipo === TipoEscopoEnum.UfOrigem || g.tipo === TipoEscopoEnum.UfDestino)) {
                    <div class="escopo-input-row">
                        <div class="escopo-input-field">
                            <app-select-pesquisavel
                                [control]="$any(g.tempControl)"
                                label="Selecionar UF"
                                [offlineList]="ufOfflineList"
                                idField="id"
                                nameField="descricaoExibicao"
                                [multiple]="true"
                                [isOptional]="true"
                                subscriptSizing="dynamic"
                                (selectionChange)="onMultiSelectChange(g, $event)">
                            </app-select-pesquisavel>
                        </div>
                    </div>
                    @if (g.valores.length > 0) {
                    <div class="status-badge-grid mt-2">
                        @for (v of g.valores; track v.codigo) {
                        <span class="status-badge badge-cinza">
                            {{ badgeLabel(v) }}
                            <button type="button" class="badge-close-btn"
                                (click)="removerValorGrupo(g, v)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </span>
                        }
                    </div>
                    }
                    }

                    <!-- Origem -->
                    @else if (g.tipo === TipoEscopoEnum.OrigemMercadoria) {
                    <div class="escopo-input-row">
                        <div class="escopo-input-field"><app-select-pesquisavel [control]="$any(g.tempControl)" label="Origem da mercadoria" [offlineList]="origemOpcoes" idField="id" nameField="descricao" [multiple]="true" [isOptional]="true" subscriptSizing="dynamic" (selectionChange)="onMultiSelectChange(g, $event)"></app-select-pesquisavel></div>
                    </div>
                    @if (g.valores.length > 0) {
                    <div class="status-badge-grid mt-2">
                        @for (v of g.valores; track v.codigo) {
                        <span class="status-badge badge-cinza">
                            {{ badgeLabel(v) }}
                            <button type="button" class="badge-close-btn"
                                (click)="removerValorGrupo(g, v)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </span>
                        }
                    </div>
                    }
                    }

                    <!-- Tipo de Item -->
                    @else if (g.tipo === TipoEscopoEnum.TipoItem) {
                    <div class="escopo-input-row">
                        <div class="escopo-input-field"><app-select-pesquisavel [control]="$any(g.tempControl)" label="Tipo de item" [offlineList]="tipoItemOpcoes" idField="id" nameField="descricao" [multiple]="true" [isOptional]="true" subscriptSizing="dynamic" (selectionChange)="onMultiSelectChange(g, $event)"></app-select-pesquisavel></div>
                    </div>
                    @if (g.valores.length > 0) {
                    <div class="status-badge-grid mt-2">
                        @for (v of g.valores; track v.codigo) {
                        <span class="status-badge badge-cinza">
                            {{ badgeLabel(v) }}
                            <button type="button" class="badge-close-btn"
                                (click)="removerValorGrupo(g, v)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </span>
                        }
                    </div>
                    }
                    }

                    <!-- NCM (input editável + lupa) -->
                    @else if (g.tipo === TipoEscopoEnum.Ncm) {
                    <div class="escopo-input-row">
                        <mat-form-field appearance="outline" class="escopo-input-field" subscriptSizing="dynamic">
                            <mat-label>NCM</mat-label>
                            <input matInput type="text" inputmode="numeric"
                                [(ngModel)]="g.valorNovo"
                                [mask]="masks.ncm"
                                placeholder="Ex: 0101.21.00, 0101 (posição)"
                                (keydown)="onNcmKeydown($event)"
                                (keydown.enter)="adicionarNcmManual(g)">
                            <button mat-icon-button matSuffix type="button"
                                matTooltip="Pesquisar NCM"
                                (click)="pesquisarNcm(g)">
                                <mat-icon>search</mat-icon>
                            </button>
                        </mat-form-field>
                        <button mat-flat-button class="btn-primary btn-add-valor" type="button"
                            [disabled]="![2,4,5,6,7,8].includes((g.valorNovo || '').replace(/\D/g,'').length)"
                            (click)="adicionarNcmManual(g)">
                            <mat-icon>add</mat-icon>
                            Adicionar
                        </button>
                    </div>
                    @if (g.valores.length > 0) {
                    <div class="status-badge-grid mt-2">
                        @for (v of g.valores; track v.codigo) {
                        <span class="status-badge badge-cinza">
                            {{ formatNcm(v.codigo) }}
                            <button type="button" class="badge-close-btn"
                                (click)="removerValorGrupo(g, v)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </span>
                        }
                    </div>
                    }
                    }

                    <!-- CEST (input editável + lupa) -->
                    @else if (g.tipo === TipoEscopoEnum.Cest) {
                    <div class="escopo-input-row">
                        <mat-form-field appearance="outline" class="escopo-input-field" subscriptSizing="dynamic">
                            <mat-label>CEST (7 dígitos)</mat-label>
                            <input matInput type="text" inputmode="numeric"
                                [(ngModel)]="g.valorNovo"
                                [mask]="masks.cest"
                                placeholder="Ex: 01.001.00"
                                (keydown)="onCestKeydown($event)"
                                (keydown.enter)="adicionarCestManual(g)">
                            <button mat-icon-button matSuffix type="button"
                                matTooltip="Pesquisar CEST"
                                (click)="pesquisarCest(g)">
                                <mat-icon>search</mat-icon>
                            </button>
                        </mat-form-field>
                        <button mat-flat-button class="btn-primary btn-add-valor" type="button"
                            [disabled]="(g.valorNovo || '').replace(/\D/g,'').length !== 7"
                            (click)="adicionarCestManual(g)">
                            <mat-icon>add</mat-icon>
                            Adicionar
                        </button>
                    </div>
                    @if (g.valores.length > 0) {
                    <div class="status-badge-grid mt-2">
                        @for (v of g.valores; track v.codigo) {
                        <span class="status-badge badge-cinza">
                            {{ formatCest(v.codigo) }}
                            <button type="button" class="badge-close-btn"
                                (click)="removerValorGrupo(g, v)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </span>
                        }
                    </div>
                    }
                    }

                    <!-- Produto (select pesquisável com API) -->
                    @else if (g.tipo === TipoEscopoEnum.Produto) {
                    <div class="escopo-input-row">
                        <div class="escopo-input-field">
                            <app-select-pesquisavel
                                [control]="$any(g.tempControl)"
                                label="Pesquisar produto"
                                [apiUrl]="produtoLookupUrl"
                                idField="idProduto"
                                nameField="descricao"
                                [isOptional]="true"
                                subscriptSizing="dynamic"
                                (selectionChange)="onSelectPesquisavelChange(g, $event)">
                            </app-select-pesquisavel>
                        </div>
                        <button mat-flat-button class="btn-primary btn-add-valor" type="button"
                            [disabled]="!g.pendingItem"
                            (click)="adicionarPendingItem(g)">
                            <mat-icon>add</mat-icon>
                            Adicionar
                        </button>
                    </div>
                    @if (g.valores.length > 0) {
                    <div class="status-badge-grid mt-2">
                        @for (v of g.valores; track v.codigo) {
                        <span class="status-badge badge-cinza">
                            {{ badgeLabel(v) }}
                            <button type="button" class="badge-close-btn"
                                (click)="removerValorGrupo(g, v)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </span>
                        }
                    </div>
                    }
                    }

                    <!-- Regime Tributário (select pesquisável offline) -->
                    @else if (g.tipo === TipoEscopoEnum.RegimeTrib) {
                    <div class="escopo-input-row">
                        <div class="escopo-input-field">
                            <app-select-pesquisavel
                                [control]="$any(g.tempControl)"
                                [label]="g.label"
                                [offlineList]="listaRegimeTributario"
                                idField="id"
                                nameField="descricao"
                                [multiple]="true"
                                [isOptional]="true"
                                subscriptSizing="dynamic"
                                (selectionChange)="onMultiSelectChange(g, $event)">
                            </app-select-pesquisavel>
                        </div>
                        <button mat-flat-button class="btn-primary btn-add-valor" type="button"
                            [disabled]="!g.pendingItem"
                            (click)="adicionarPendingItem(g)">
                            <mat-icon>add</mat-icon>
                            Adicionar
                        </button>
                    </div>
                    @if (g.valores.length > 0) {
                    <div class="status-badge-grid mt-2">
                        @for (v of g.valores; track v.codigo) {
                        <span class="status-badge badge-cinza">
                            {{ badgeLabel(v) }}
                            <button type="button" class="badge-close-btn"
                                (click)="removerValorGrupo(g, v)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </span>
                        }
                    </div>
                    }
                    }

                    <!-- Tipo Tributário da contraparte (select pesquisável offline) -->
                    @else if (g.tipo === TipoEscopoEnum.TipoTributario) {
                    <div class="escopo-input-row">
                        <div class="escopo-input-field">
                            <app-select-pesquisavel
                                [control]="$any(g.tempControl)"
                                [label]="g.label"
                                [offlineList]="listaTipoTributario"
                                idField="id"
                                nameField="descricao"
                                [multiple]="true"
                                [isOptional]="true"
                                subscriptSizing="dynamic"
                                (selectionChange)="onMultiSelectChange(g, $event)">
                            </app-select-pesquisavel>
                        </div>
                        <button mat-flat-button class="btn-primary btn-add-valor" type="button"
                            [disabled]="!g.pendingItem"
                            (click)="adicionarPendingItem(g)">
                            <mat-icon>add</mat-icon>
                            Adicionar
                        </button>
                    </div>
                    @if (g.valores.length > 0) {
                    <div class="status-badge-grid mt-2">
                        @for (v of g.valores; track v.codigo) {
                        <span class="status-badge badge-cinza">
                            {{ badgeLabel(v) }}
                            <button type="button" class="badge-close-btn"
                                (click)="removerValorGrupo(g, v)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </span>
                        }
                    </div>
                    }
                    }
                    @if (g.valores.length === 0) { <app-empty-state icon="inbox" [title]="'Nenhum valor adicionado para ' + g.label" subtitle="Sem seleção, este critério não restringe a exceção."></app-empty-state> }
                    </div> } }
                </div> }
            </div>
        </div>
        }

        <!-- ── Passo 2: Vigência ──────────────────────────────────────────────── -->
        @if (passo === 1) {
        <div [formGroup]="step2">

            <div class="row g-3 mt-1">
                <div class="col-12 col-md-5">
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                        <mat-label>Vigência início <span class="required">*</span></mat-label>
                        <input matInput [matDatepicker]="pickerInicio"
                            [(ngModel)]="dataVigenciaInicio"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="DD/MM/AAAA"
                            inputmode="numeric"
                            maxlength="10"
                            [max]="dataVigenciaFim"
                            (ngModelChange)="onVigenciaChange('inicio', $event)"
                            (input)="onDateInput($event)"
                            (keydown)="onDateKeydown($event)"
                            (blur)="onVigenciaBlur($event, 'inicio')">
                        <mat-datepicker-toggle matIconSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                        <mat-datepicker #pickerInicio></mat-datepicker>
                        @if (!step2.get('dataVigenciaInicio')?.value && step2.get('dataVigenciaInicio')?.touched) {
                        <mat-error>Data de início é obrigatória.</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-5">
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                        <mat-label>Vigência fim (opcional)</mat-label>
                        <input matInput [matDatepicker]="pickerFim"
                            [(ngModel)]="dataVigenciaFim"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="DD/MM/AAAA"
                            inputmode="numeric"
                            maxlength="10"
                            [min]="dataVigenciaInicio"
                            (ngModelChange)="onVigenciaChange('fim', $event)"
                            (input)="onDateInput($event)"
                            (keydown)="onDateKeydown($event)"
                            (blur)="onVigenciaBlur($event, 'fim')">
                        <mat-datepicker-toggle matIconSuffix [for]="pickerFim"></mat-datepicker-toggle>
                        <mat-datepicker #pickerFim></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
        }

        <!-- ── Passo 3: Parâmetros tributários ──────────────────────────────── -->
        @if (passo === 2) {
        <div>

            <!-- Seção: Regra de Exceção (espelho da aba SN) -->
            <app-cofins-tributo-regra-section
                [form]="step3"
                [codigoTributos]="data.codigoTributos"
                [modalidadesBcSt]="data.modalidadesBcSt"
                [modoExcecao]="true"
                [personalizadasCount]="personalizadasCount"
                [personalizarDisabled]="formulasParaCodigoTributo.length === 0"
                [tipoOperacao]="data.tipoOperacao"
                (personalizar)="abrirEditorFormulas()">
            </app-cofins-tributo-regra-section>

            <!-- Seção: Observações -->
            <app-cofins-tributo-observacoes-section
                [control]="$any(step3.get('observacao'))"
                titulo="Informações complementares"
                icone="notes"
                placeholder="Texto da observação que será impresso no documento fiscal. Use {tag} para inserir variáveis dinâmicas."
                [variaveisInline]="true"
                [variaveis]="step3.get('cstCofins')?.value ? data.variaveis : []">
            </app-cofins-tributo-observacoes-section>

            <!-- Seção: Informações adicionais ao fisco -->
            <app-cofins-tributo-observacoes-fisco-section
                [control]="$any(step3.get('observacaoFisco'))"
                titulo="Informações adicionais ao fisco"
                icone="account_balance"
                placeholder="Texto das informações adicionais de interesse do fisco. Use {tag} para inserir variáveis dinâmicas."
                [variaveisInline]="true"
                [variaveis]="step3.get('cstCofins')?.value ? data.variaveis : []">
            </app-cofins-tributo-observacoes-fisco-section>

        </div>
        }

    </mat-dialog-content>

    <!-- Footer -->
    <mat-dialog-actions class="modal-footer wizard-footer">
        <button mat-stroked-button class="btn-secondary" type="button" (click)="fechar()">Cancelar</button>
        <div class="ms-auto d-flex gap-2">
            @if (passo > 0) {
            <button mat-stroked-button class="btn-secondary" type="button" (click)="voltar()">
                Voltar
            </button>
            }
            @if (passo < passos.length - 1) {
            <button mat-flat-button class="btn-primary" type="button" (click)="avancar()">
                Próximo
            </button>
            }
            @if (passo === passos.length - 1) {
            <button mat-flat-button class="btn-primary btn-spinner" type="button" [class.btn-loading]="salvando"
                [disabled]="salvando" [attr.aria-label]="salvando ? 'Salvando exceção' : 'Salvar exceção'"
                (click)="salvar()">
                Salvar exceção
                @if (salvando) { <mat-spinner diameter="20"></mat-spinner> }
            </button>
            }
        </div>
    </mat-dialog-actions>
